import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { ActionLogService } from '../../services/action-log.service';
import { UserAvatarComponent } from '../user/user-avatar/user-avatar.component';
import { BusinessAvatarComponent } from '../business/business-avatar/business-avatar.component';

@Component({
  selector: 'brt-action-log-list',
  standalone: true,
  imports: [CommonModule, TableModule, UserAvatarComponent, BusinessAvatarComponent],
  templateUrl: './action-log-list.component.html',
  styleUrl: './action-log-list.component.scss'
})
export class ActionLogListComponent {
  private actionLogService = inject(ActionLogService);

  @Input({ required: true }) criteria: any = {};

  logs: any[] = [];
  total = 0;
  loading = false;

  async ngOnInit() {
    await this.load();
  }

  private async load() {
    this.loading = true;
    const { List, Total } = await this.actionLogService.search(this.criteria);
    this.logs = List;
    this.total = Total;
    this.loading = false;
  }
}
